import styled from 'styled-components';

export const Container = styled.div``;
export const ContainerPeoples = styled.div`
  img {
    z-index: 1;
  }

  @-moz-document url-prefix() {
    img {
      width: 140%;
    }
  }
`;
export const Content = styled.div`
  max-width: 1120px;
  margin: 0 auto;
`;

export const ImageContainer = styled.div`
  background-color: #699fff;
  display: flex;

  height: 350px;

  &::before {
    content: '';
    display: block;
    position: absolute;
    height: 160px;
    width: 100%;
    background-color: #215df4;
  }

  @media screen and (max-width: 768px) {
    background-color: #215df4;
    height: 500px;
    &::before {
      content: none;
      display: none;
    }
  }
`;

export const ImageContent = styled.div`
  max-width: 1120px;
  margin: 0 auto;
  padding-top: 1.5em;

  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  @media screen and (max-width: 768px) {
    align-items: center;
    flex-direction: column-reverse;
  }
`;

export const TextContent = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 25px;
  p {
    font-family: 'Inter', sans-serif;
    font-weight: 500;
  }

  @media screen and (max-width: 768px) {
    margin-top: 100px;
    padding: 0 1em;
    img {
      width: 50%;
    }
  }
`;
